import { LoadingStatuses } from 'core/common/entities';
import { emptyOffers, Offer, Offers, UpsellDeprecated } from '../entities';

export type OffersState = {
  loadingStatus: LoadingStatuses;
  selectedOffer: Offer | null;
  selectedUpsell: UpsellDeprecated | null;
  entries: Array<Offers>;
  offerDetailsLoadingStatus: LoadingStatuses;
  selectedTrialOffer: Offer | null;
};

export const offersInitialState: OffersState = {
  loadingStatus: LoadingStatuses.IDLE,
  offerDetailsLoadingStatus: LoadingStatuses.IDLE,
  selectedOffer: null,
  selectedUpsell: null,
  selectedTrialOffer: null,
  entries: [emptyOffers],
};
